module.exports = "e522612b27eb712237a4c2d5af38a272.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/undo.png
// module id = 72
// module chunks = 0